import { useAsync } from 'react-async-hook'
import { getSubscription } from './PaymentService'

export function useSubscription(userId) {
  return useAsync(getSubscription, [userId])
}

